var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"insurance-list-items"},[_c('img',{staticClass:"logo",attrs:{"src":_vm.icon}}),_vm._v(" "),_c('div',{staticClass:"meta"},[_c('router-link',{staticClass:"name",attrs:{"to":_vm.route}},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('p',{staticClass:"desc"},[_vm._v(_vm._s(_vm.subtitle))])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }